import { useEffect } from 'react'
import { useProductsStore } from '../stores/productsStore'

export const useProducts = () => {
  const {
    products,
    currentProduct,
    isLoading,
    error,
    filters,
    fetchProducts,
    fetchProduct,
    createProduct,
    updateProduct,
    deleteProduct,
    setFilters,
    resetFilters,
  } = useProductsStore()

  useEffect(() => {
    // Only fetch if no products and not loading
    if (!products && !isLoading) {
      fetchProducts()
    }
  }, [products, isLoading, fetchProducts])

  const refetch = () => {
    fetchProducts()
  }

  return {
    products,
    currentProduct,
    isLoading,
    error,
    filters,
    fetchProducts,
    fetchProduct,
    createProduct,
    updateProduct,
    deleteProduct,
    setFilters,
    resetFilters,
    refetch,
  }
}